import { Modal } from '@unified-checkout/design-system';

import { MOBILE_BREAKPOINT } from '@app/dashboard/constants/break-points';
import { useScreenWidth } from '@app/dashboard/hooks/useScreenWidth';

import { IConfirmationModalProps } from '@app/dashboard/types/innerLayout/risk_center/modals/confirmation-modal';

import styles from './confirmation-modal.module.scss';

export const ConfirmationModal = ({
  open,
  modalContent: { title, supportingText, modalState },
  primaryBtn: {
    text: primaryBtnText,
    color,
    onClick: onPrimaryClick,
    loading: loading,
    disabled: disabled,
  },
  secondaryBtn: {
    text: secondaryBtnText,
    onClick: handleCancel,
    color: secondaryBtnColor = 'secondary',
    disabled: secondaryBtnDisabled = false,
  },
  children,
}: IConfirmationModalProps) => {
  const screenWidth = useScreenWidth();
  const isMobile = screenWidth <= MOBILE_BREAKPOINT;

  return (
    <Modal
      wrapperClassName={styles['confirmation-modal']}
      isOverlayAboveModal
      isMobile={isMobile}
      closeOnClickOutside={false}
      state={modalState || 'danger'}
      open={open}
      title={title}
      supportingText={supportingText}
      btnsProps={[
        {
          size: 'lg',
          color: color,
          variant: 'contained',
          text: primaryBtnText,
          onClickHandler: onPrimaryClick,
          loading: loading,
          disabled: disabled,
        },
        {
          size: 'lg',
          color: secondaryBtnColor,
          variant: 'outlined',
          text: secondaryBtnText,
          onClickHandler: handleCancel,
          disabled: secondaryBtnDisabled,
        },
      ]}
    >
      {children}
    </Modal>
  );
};
